//import 'babel-polyfill';
import AxL from './axl';
import { DdspMusicController } from './DdspMusicController';
import { BrushCanvas } from './BrushCanvas';
import { NotesGrid } from './NotesGrid';
import { TimelineCanvas } from './TimelineCanvas';
import { PlaybackHighlight } from './PlaybackHighlight';
import { Frame } from './Frame';
import { Shapes } from './Shapes';
import { PenToolCursor } from './PenToolCursor';
import { AtmosphereSelector } from './AtmosphereSelector';
import { Background } from './Background';
import { Buttons } from './Buttons';
import { Soundscapes } from './Soundscapes';
import { Sharing } from './Sharing';
import { About } from './About';
import { IntroGIF } from './IntroGIF';
import { HelperMessages } from './HelperMessages';
import { MemoryChecker } from './MemoryChecker';
import { Limiter } from './Limiter';
import { getComplementaryColor, getOverlayColor } from './utils';
import Translator from './Translator';
import Tooltips from './Tooltips';
//import share_test_data from './assets/share_test.json'

const MAX_READY_WAITING_TIME = 1800; // milliseconds
const LOOP_DURATION = 6000; // milliseconds
const DRAW_MAX_DURATION = 5000; // milliseconds
const IS_TOUCH =
  'ontouchstart' in window ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;
const IS_MOBILE = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const IS_MACOS = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
const IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
// ddsp does not work on iOS devices...
let NO_DDSP = IS_IOS || (IS_MACOS && IS_TOUCH);

// with the exception of iPhone 11!
// We will detect by screen resolution. not the best, but...
const iphone11Res = { w: 414, h: 896 };
const OS_EXCEPTIONS = [iphone11Res];
OS_EXCEPTIONS.forEach((exceptionSize) => {
  if (
    IS_IOS &&
    window.screen.width == exceptionSize.w &&
    window.screen.height == exceptionSize.h
  ) {
    NO_DDSP = false;
  }
});

// Display an error message in safari, if there is not alredy one (if NO_DDSP = true)
const IS_SAFARI_DESKTOP = !IS_MOBILE && IS_SAFARI && !NO_DDSP;
// When to send the event "draw" to stella, with the number of strokes
const NUM_STROKES_TO_TRACK = [1, 5, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90];

let loopedTime = 0;
let startInitiated = false;
let isWarm = false;

// Drawing
const state = {
  isInSharedMode: false,
  isBlocked: false,
  hasDrawn: false,
  appStarted: false,
  playBackMode: 'time',
  drawMode: 'paint', // or 'stamp'
};

if (IS_MOBILE) {
  document.body.classList.add('mobile');
} else {
  document.body.classList.add('nomobile');
}
if (IS_TOUCH) {
  document.body.classList.add('touch');
} else {
  document.body.classList.add('notouch');
}

// UI Elements
const mainLoader = document.getElementById('main-loader');
const canvasContainer = document.getElementById('container');
const playContainer = document.getElementById('play-container');
const sharedWelcomeElement = document.getElementById('shared-welcome');
const loaderText = document.getElementById('loading-text');

// Window size
const size = {
  width: window.innerWidth,
  height: window.innerHeight,
};
let mouseX = 0;
let mouseY = 0;

// Objects
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let sharedId = urlParams.has('id') ? urlParams.get('id') : ''; // TODO no more URLSearchParams in prod
let startAtmopshere = '';
const axl = sharedId.length ? null : new AxL();

const shapes = new Shapes(onShapesChange, IS_MOBILE || IS_TOUCH || IS_SAFARI);
const translator = new Translator();
const frame = new Frame(canvasContainer);
const buttons = new Buttons(frame, LOOP_DURATION);
const musicController = new DdspMusicController(
  LOOP_DURATION,
  NO_DDSP,
  shapes,
  buttons
);
const canvas = new BrushCanvas(
  canvasContainer,
  shapes,
  DRAW_MAX_DURATION,
  onDrawStart,
  onDrawEnd
);
const atmosphereSelector = new AtmosphereSelector(
  canvas,
  canvasContainer,
  translator
);
const notesGrid = new NotesGrid(canvasContainer);
const timeline = new TimelineCanvas(canvasContainer);
const playbackHighlight = new PlaybackHighlight(canvasContainer, shapes);
const background = new Background(IS_MOBILE);
const introGIF = new IntroGIF();
const soundScapes = new Soundscapes();
const limiter = new Limiter();
const sharing = new Sharing(
  axl,
  shapes,
  canvas.canvas,
  translator,
  buttons,
  limiter.value
);
const about = new About(axl, translator);
const helperMessages = new HelperMessages(axl, playbackHighlight);
const tooltips = !IS_TOUCH ? new Tooltips() : null;
const memoryChecker = new MemoryChecker();

const loadingTexts = [
  translator.dictionary.loading_flute,
  translator.dictionary.loading_violin,
  translator.dictionary.loading_saxo,
  translator.dictionary.loading_trumpet,
  translator.dictionary.loading_birds,
  translator.dictionary.loading_AI,
  translator.dictionary.loading_whales,
  translator.dictionary.loadding_spray,
];
let loadingTextIndex = Math.round(Math.random() * (loadingTexts.length - 1));
let loadingTextTimer = null;
let penTool = null;

function start() {
  if (axl) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'page_load',
    });
  }
  initListeners();
  resize();
  musicController.init();
  window.requestAnimationFrame(update);
  setTimeout(appReady, MAX_READY_WAITING_TIME);

  loaderText.textContent = loadingTexts[loadingTextIndex];
  loadingTextTimer = window.setInterval(() => {
    loadingTextIndex++;
    loaderText.textContent =
      loadingTexts[loadingTextIndex % loadingTexts.length];
  }, 2000);
}

function initListeners() {
  document.addEventListener('introCompleted', onIntroCompleted);
  document.addEventListener('loadingModelEnd', onLoadingModelEnd);
  document.addEventListener('warmupEnded', onWarmUpEnded);
  document.addEventListener('loopStarted', onLoopStarted);
  document.addEventListener('loopPaused', onLoopPaused);
  document.addEventListener('audioAdded', onAudioAdded);
  document.addEventListener('atmosphereChanged', changeAtmosphere);
  document.addEventListener('undo', undo);
  document.addEventListener('pause', () => {
    pause(false);
  });
  document.addEventListener('clear', clear);
  document.addEventListener('share', onShare);
  document.addEventListener('toggleGrid', toggleGrid);
  document.addEventListener('toggleTempo', toggleTempo);
  document.addEventListener('togglePlayPause', togglePlayPause);
  document.addEventListener('instrumentChanged', onInstrumentChanged);
  document.addEventListener('atmosphereMenuUpdate', onAtmosphereMenuChanged);
  document.addEventListener('createMyOwn', onSharedStartNew);
  document.addEventListener('setUnsupported', onSetUnsupported);
  window.addEventListener('resize', resize);
}

function initUiListerners() {
  if (!state.isInSharedMode) {
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchend', onUp);
    window.addEventListener('touchmove', onMove);
    canvasContainer.addEventListener('mousedown', onDown);
    canvasContainer.addEventListener('touchstart', onDown);
  }
}

function onDown(e) {
  e.preventDefault();
  canvas.down(e);
  if (penTool) {
    penTool.down();
  }
}

function onUp(e) {
  canvas.up(e);
  if (penTool) {
    penTool.up();
  }
}

function onMove(e) {
  e.preventDefault();
  if (e.touches && e.touches.length) {
    mouseX = e.touches[0].clientX;
    mouseY = e.touches[0].clientY;
  } else if (!e.touches) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  }
  // move the items on the canvas
  canvas.move(e);
}

function resize() {
  size.width = window.innerWidth;
  size.height = window.innerHeight;

  canvas.resize();
  timeline.resize(canvas.width, canvas.height);
  playbackHighlight.resize(canvas.width, canvas.height);
  frame.resize(canvas.width, canvas.height);
  musicController.updatePitchMargin(canvas.width, canvas.height);
  buttons.resize();

  notesGrid.drawGrid(
    musicController.getKeyPitchLines(musicController.currentInstrumentIndex),
    canvas.width,
    canvas.height
  );

  atmosphereSelector.resize(size);
  helperMessages.resize();
}

function update(timestamp) {
  const loopProgress = musicController.loop.progress;
  loopedTime = loopProgress * LOOP_DURATION;
  canvas.update(timestamp, loopedTime);
  buttons.update(loopProgress);
  playbackHighlight.update(loopedTime);
  if (penTool) {
    penTool.update(timestamp, mouseX, mouseY);
  }
  helperMessages.helperCanvas.update(timestamp);
  window.requestAnimationFrame(update);
}

function startApp() {
  // START !
  if (axl) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'start_app',
    });
  }
  state.appStarted = true;
  musicController.initTone();
  introGIF.hide();

  frame.start();
  canvas.activate();
  canvas.start();
  clear(false);
  buttons.init();
  initUiListerners();
  // show ui
  document.getElementById('header').classList.add('shown');
  buttons.show();

  createPenTool();

  about.start(NO_DDSP, state.isInSharedMode);
  if (IS_SAFARI_DESKTOP) about.showSafariWarning();
}

function createPenTool() {
  if (!state.isInSharedMode) {
    helperMessages.showStartCanvasHelper();
    if (!IS_TOUCH) {
      penTool = new PenToolCursor(canvasContainer);
      penTool.show();
    }
  }
}

function onWarmUpEnded() {
  if (axl) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'warm_up_complete',
      nonInteraction: true,
      //TODO: Add the time it took to warm up the model (ms)
      //value: 1000
    });
  }
  document.removeEventListener('warmupEnded', onWarmUpEnded);
  mainLoader.parentElement.removeChild(mainLoader);
  window.clearInterval(loadingTextTimer);
  loadingTextTimer = null;
  isWarm = true;
  if (!startInitiated) {
    appReady();
  } else {
    startSite();
  }
}

function onLoopStarted() {
  playContainer.classList.add('playing');
}

function onLoopPaused() {
  playContainer.classList.remove('playing');
}

function onIntroCompleted() {
  if (axl) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'intro_complete',
      nonInteraction: true,
    });
  }
  if (
    !state.appStarted &&
    !state.isInSharedMode &&
    startAtmopshere &&
    startAtmopshere.length
  ) {
    atmosphereSelector.currentAtmosphere =
      atmosphereSelector.getDataById(startAtmopshere);
    changeAtmosphere(false);
    // register that we have already picked an atmosphere
    atmospheres.isFirstPick = false;
  } else {
    atmosphereSelector.show();
  }
}

function onLoadingModelEnd() {
  // clear the console if we are in prod
  /*if (!window.location.href.includes("localhost")) {
    console.clear();
  }*/
  if (axl) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'model_loaded',
      nonInteraction: true,
    });
  }
  musicController.warmUpModel();
}

function changeAtmosphere(trackEvent = true) {
  if (!state.appStarted) {
    startApp(trackEvent);
  }

  hideGrid();
  const atmosphereData = atmosphereSelector.currentAtmosphere;
  if (axl && trackEvent) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'change_atmosphere',
      label: atmosphereData.id,
    });
  }

  atmosphereSelector.hide();
  if (atmosphereSelector.selectedId !== atmosphereData.id) {
    clear(false);
    background.changeAtmosphere(atmosphereData);
    musicController.changeAtmosphere(atmosphereData);
    canvas.changeAtmosphere(atmosphereData);
    playbackHighlight.updateColors(atmosphereData.instrumentColors);
    buttons.changeAtmosphere(atmosphereData);
    notesGrid.changeColor(atmosphereData.noteGridColor);
    soundScapes.load(atmosphereData.soundtrack);
    frame.changeTitleColor(atmosphereData.noteGridColor);
    sharing.changeAtmosphere(atmosphereData.id);
    const { isStamp } = buttons.getInstrumentProperties(
      buttons.currentInstrumentIndex
    );
    changeInstrument(isStamp ? 0 : buttons.currentInstrumentIndex, false);
    helperMessages.changeAtmosphere(atmosphereData);

    if (playContainer.classList.contains('shown') && !state.isInSharedMode) {
      resume(false);
    }
  }
  atmosphereSelector.select(atmosphereData.id, state.isInSharedMode);
  about.changeScaleInfo(atmosphereData.id);
  if (axl && !state.isInSharedMode) {
    axl.sendMessage(AxL.ChildToHost.SET_URL_PARAMS, {
      atmosphere: atmosphereData.id,
    });
  }
}

function onAtmosphereMenuChanged() {
  frame.menuChange(atmosphereSelector.shown);
  about.close();
  about.closeScaleInfo();
  helperMessages.closeAll();
}

function toggleGrid() {
  notesGrid.toggleGrid();
  buttons.changeGridState(notesGrid.shown);
  if (axl) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'toggle_grid',
      label: notesGrid.shown,
    });
  }
  about.close();
  if (notesGrid.shown) about.openScaleInfo();
  else about.closeScaleInfo();
  // show the more info box on the grid
  helperMessages.closeAll();
}

function toggleTempo() {
  musicController.toggleTempo();
  buttons.changeTempoState(musicController.isTempoActive);
  if (axl) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'toggle_tempo',
      label: musicController.isTempoActive,
    });
  }
  about.close();
}

function hideGrid() {
  notesGrid.hide();
  about.closeScaleInfo();
  buttons.changeGridState(notesGrid.shown);
}

function togglePlayPause() {
  if (musicController.isPlaying()) {
    pause();
  } else {
    musicController.initTone();
    resume();
  }
}

function resume(trackEvent = true) {
  musicController.start();
  soundScapes.resume();
  if (state.isInSharedMode) {
    sharedWelcomeElement.classList.remove('shown');
  }
  if (axl && trackEvent) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'toggle_play_pause',
      label: 'play',
    });
  }
}

function pause(trackEvent = true) {
  musicController.pause();
  soundScapes.pause();
  if (axl && trackEvent) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'toggle_play_pause',
      label: 'pause',
    });
  }
}

function onInstrumentChanged() {
  changeInstrument(buttons.currentInstrumentIndex);
}

function changeInstrument(index, trackEvent = true) {
  if (axl && trackEvent) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'change_instrument',
      label: index,
    });
  }
  const { id, color, isStamp } = buttons.getInstrumentProperties(index);
  const complementaryColor = getComplementaryColor(color);
  const penMode = isStamp ? 'stamp' : 'brush';
  const overlayColor = getOverlayColor(
    color,
    complementaryColor,
    atmosphereSelector.currentAtmosphere.averageBackgroundColor
  );
  buttons.selectInstrument(index, color, complementaryColor);
  canvas.changeInstrument(index, id, color, isStamp);
  frame.changeColor(color, complementaryColor);
  about.changeColor(color, complementaryColor);
  helperMessages.changeColor(
    overlayColor,
    atmosphereSelector.currentAtmosphere,
    color
  );
  atmosphereSelector.changeColor(color, complementaryColor);
  buttons.changeGridState(notesGrid.shown);
  musicController.setColor(overlayColor);
  if (penTool) {
    if (penTool.activeMode != penMode) penTool.changeMode(penMode);
    penTool.changeColor(color);
  }
  if (tooltips) {
    tooltips.changeColor(color, complementaryColor);
  }

  if (isStamp) {
    state.drawMode = 'stamp';
    musicController.setCurrentStamp(id);
  } else {
    state.drawMode = 'paint';
    musicController.setCurrentInstrument(index);
  }

  notesGrid.drawGrid(
    musicController.getKeyPitchLines(musicController.currentInstrumentIndex),
    canvas.width,
    canvas.height
  );

  about.close();
  about.closeScaleInfo();
  helperMessages.instrumentChanged(index);
}

function startPlaying() {
  musicController.start();
  soundScapes.resume();
  playContainer.classList.add('shown');
}

function onDrawStart(point) {
  if (axl && NUM_STROKES_TO_TRACK.includes(shapes.history.length)) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'draw',
      value: shapes.history.length,
    });
  }
  if (point.isStamp) {
    musicController.addStamp(point.screenY, point);
    // for undo and resize :
    shapes.save(canvas.canvas, true);
  }
  startPlaying();
  if (!state.hasDrawn) {
    musicController.initTone();
    state.hasDrawn = true;
    helperMessages.hideStartCanvasHelper();
  }
}

function onDrawEnd() {
  musicController.generateAudio(
    shapes.getCurrentStroke(),
    canvas.canvas.height
  );
  // for undo and resize :
  shapes.save(canvas.canvas);
}

function unblock() {
  if (state.isBlocked) {
    state.isBlocked = false;
    memoryChecker.hasAlarmed = false;
    if (!state.isInSharedMode) {
      canvasContainer.addEventListener('mousedown', onDown);
      canvasContainer.addEventListener('touchstart', onDown);
      window.addEventListener('mouseup', onUp);
      window.addEventListener('touchend', onUp);
    }
    limiter.hideMessage();
    musicController.unblock();
  }
}

function onAudioAdded() {
  memoryChecker.check();
  if (memoryChecker.hasAlarmed || shapes.history.length > limiter.value) {
    // block !
    state.isBlocked = true;
    canvasContainer.removeEventListener('mousedown', onDown);
    canvasContainer.removeEventListener('touchstart', onDown);
    window.removeEventListener('mouseup', onUp);
    window.removeEventListener('touchend', onUp);
    limiter.showMessage(shapes.history.length, memoryChecker.value);
    musicController.block();
  }
}

function clear(trackEvent = true) {
  if (axl && trackEvent) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'clear',
    });
  }

  shapes.clear();
  canvas.clear();
  musicController.reset();
  timeline.clear();
  buttons.clear();
  about.close();
  helperMessages.closeAll();
  unblock();
}

function undo() {
  if (axl) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'undo',
    });
  }

  const shape = shapes.undo();
  if (shape) {
    canvas.redraw();
    musicController.remove(shape);
  }
  about.close();
  helperMessages.closeAll();
  unblock();
}

function onSetUnsupported() {
  // sound is not supported on this device
  about.start(true, state.isInSharedMode);
}

function onShapesChange() {
  buttons.shapesChanged(shapes);
  if (!state.isInSharedMode && shapes.history.length > 2) {
    helperMessages.showInstrumentHelper();
  }
  if (!state.isInSharedMode && shapes.history.length > 5) {
    helperMessages.showSharingHelper();
  }
}

let readyHandshaked = false;
let firstResume = true;
let isPausedFromAxl = false;

function appReady() {
  if (readyHandshaked) {
    return;
  }
  readyHandshaked = true;

  if (axl) {
    axl.handshake().then((params) => {
      if ('id' in params) {
        sharedId = params.id;
      }
      if (
        'atmosphere' in params &&
        params.atmosphere &&
        params.atmosphere.length &&
        atmosphereSelector.isValidAtmosphere(params.atmosphere)
      ) {
        startAtmopshere = params.atmosphere;
      }
    });

    axl.registerMessageCallback(AxL.HostToChild.FREEZE, () => {
      if (musicController.isPlaying()) {
        isPausedFromAxl = true;
        pause(false);
      }
    });

    axl.registerMessageCallback(AxL.HostToChild.RESUME, () => {
      if (firstResume) {
        firstResume = false;
        startInitiated = true;
        if (isWarm) {
          startSite();
        }
      } else if (isPausedFromAxl) {
        isPausedFromAxl = false;
        if (!musicController.isPlaying()) {
          resume(false);
        }
      }
    });
  } else {
    startInitiated = true;
    if (isWarm) {
      startSite();
    }
  }
}

function startDefault() {
  if (axl) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'start_default',
      nonInteraction: true,
    });
  }
  introGIF.show();
  background.loadIntroVideo();
}

function onShare() {
  helperMessages.shared();
}

function onSharedStartNew() {
  if (axl) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'shared_start_new',
      label: 'Create My Own',
    });
  }
  state.isInSharedMode = false;
  canvas.sharedImageBackground = null;
  initUiListerners();
  document.body.classList.remove('shared');
  pause(false);
  clear(false);
  atmosphereSelector.show(false);
  if (!penTool) {
    createPenTool();
  }
}

function startShared(data, imageUrl) {
  if (axl) {
    axl.sendMessage(AxL.ChildToHost.TRACK, {
      action: 'start_shared_view',
    });
  }
  sharing.setShapesFromData(data, LOOP_DURATION);
  const img = new Image();
  img.onload = function () {
    canvas.drawSharedImage(img);
    musicController.generateSharedAudios(0, img.height);
    buttons.shapesChanged(shapes);
    pause(false);
    buttons.playBackCircle.changeColor('#ffffff', '#191919');
    playContainer.classList.add('shown');
    sharedWelcomeElement.classList.add('shown');
  };
  img.src = imageUrl;
  //img.src = require("url:../src/assets/share_test.png");
}

async function startSite() {
  if (sharedId) {
    // load the shared creation
    //const data = share_test_data;
    const data = await sharing.get(sharedId);
    if (
      'data' in data &&
      'shapes' in data.data &&
      data.data.shapes.length &&
      'image' in data.data &&
      'atmosphere' in data.data
    ) {
      state.isInSharedMode = true;
      document.body.classList.add('shared');

      atmosphereSelector.currentAtmosphere = atmosphereSelector.getDataById(
        data.data.atmosphere
      );
      changeAtmosphere(false);
      startShared(data.data, sharing.getImageUrl(data.data));
    } else {
      startDefault();
    }
  } else {
    startDefault();
  }
}

start();
